import { helper } from '@ember/component/helper';
import urlType from '../utils/url-type';

export default helper(function (positional /*, named*/) {
  let [url] = positional;

  return urlType(url);
});